export default "3de389cd5a0e8a4f.svg"